import React, { useState } from 'react';
import cn from 'classnames';
import { ReactComponent as ProfileIcon } from '@assets/images/profile_icon.svg';
import styles from './TogoContentHeader.module.scss';
import { findCountryCode } from '@utility/countryCode';
import TogoCreateCheckModal from '../../../../StoreChecks/Modals/TogoCreateCheckModal';
import FullWithModal from '@components/common/Modal/FullWidthModal';
import { safeJsonParse } from '@utility/helperFunction';

const TogoContentHeader = ({ seat = {}, serverAppTheme = {} }) => {
  const checkInfo = safeJsonParse(
    window.sessionStorage.getItem('callCenterUserInfo'),
    {}
  );

  const countryCode = safeJsonParse(
    window.sessionStorage.getItem('auth').countryCode,
    1
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const codeToShow = () => {
    const { code, dialCode, name } = findCountryCode(checkInfo?.countryCode || '1');
    return `${code} (+${dialCode})`;
  };

  return (
    <div
      style={{ height: '40px' }}
      className="row w-95 d-flex p-0 m-0 align-items-start fs-16 fw-600"
    >
      <div
        className={cn(
          'w-25 mr-2 d-flex justify-content-between align-items-center py-1',
          styles.inputBox
        )}
        onClick={() => setIsModalOpen(true)}
      >
        <div className="w-20 d-flex justify-content-center">
          <ProfileIcon
            height="100%"
            width="100%"
            className="pr-1"
            fill={serverAppTheme.iconcolor}
          />
        </div>
        <div className="w-80 p-0 m-0 overflowXHidden text-truncate d-flex align-items-center">
          {checkInfo?.name.length > 10 ? `${checkInfo?.name.slice(0,10)}...` : checkInfo?.name} 
        </div>
      </div>
      <div
        className={cn(
          'w-45 mr-2 position-relative d-flex justify-content-center align-items-center py-1',
          styles.inputBox
        )}
        onClick={() => setIsModalOpen(true)}
      >
        <div className="mr-1">{codeToShow()}</div>
        <div className="w-60 text-truncate p-0">{checkInfo?.phoneNumber}</div>
      </div>
      <div
        className={cn('w-25 text-truncate py-1', styles.inputBox)}
        onClick={() => setIsModalOpen(true)}
      >
        {checkInfo?.pickupTime?.[0]}
      </div>
      {isModalOpen && (
        <FullWithModal
          isOpen={isModalOpen}
          isModalCenter
          editCallCenter={true}
          className={cn('h-100')}
        >
          <TogoCreateCheckModal
            editCallCenter={true}
            seat={seat}
            serverAppTheme={serverAppTheme}
            isLandScape={true}
            isTogo={true}
            setEditTogoModal={setIsModalOpen}
            editTogoModal={isModalOpen}
          />
        </FullWithModal>
      )}
    </div>
  );
};

const MemoizedHeader = React.memo(TogoContentHeader);

export default MemoizedHeader;
